import ReceiptPosition from '../../../../../../../../../../types/api/receipt-position'

export function setEditing(
    columns: any[],
    onSave: (record: ReceiptPosition, formValues: any) => void
): any[] {
    return columns.map(item => {
        if (!item.editable) {
            return item
        } else {
            return {
                ...item,
                onCell: (record: any, index: number) => {
                    const initialProps = item.onCell ? item.onCell(record, index) : {}

                    return {
                        ...initialProps,
                        record: record,
                        title: item.title,
                        dataIndex: item.dataIndex,
                        editable:
                            'editable' in initialProps ? initialProps.editable : item.editable,
                        FormItem: item.FormItem,
                        handleSave: onSave,
                        relationPath: item.relationPath,
                    }
                },
            }
        }
    })
}

export function getCheckedKeys(columnItems: any[], keys: any[] = []): any[] {
    keys.push(
        ...columnItems.map(item => {
            keys.push(item.dataIndex)
            return item.children ? getCheckedKeys(item.children, keys) : item.dataIndex
        })
    )

    return keys
}

export function getTreeItems(columnItems: any[]): any {
    return columnItems.map(item => {
        return {
            title: item.title,
            key: item.dataIndex,
            children: item.children ? getTreeItems(item.children) : [],
        }
    })
}
